import React, { useEffect } from 'react'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { eInventoryCheckSteps, SharedStateType } from '../../types'
import { Box, Typography } from '@mui/material'
import { useStyles } from '../styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import PulsingIcon from '../../../../components/_WMS/_icons/PulsingIcon'

interface SuccessInventoryCheckProps extends StepProps<SharedStateType> {}

export const SuccessInventoryCheck: React.FC<SuccessInventoryCheckProps> = ({
  goToStep,
  sharedState: { positionCode }
}) => {
  const classes = useStyles()

  useEffect(() => {
    setTimeout(() => {
      goToStep(eInventoryCheckSteps.ShowInventoryCheckPositions)
    }, 3000)
  }, [])

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <PulsingIcon
          maxScale={4}
          duration='1.5s'
          IconComponent={CheckCircleOutlineIcon}
          color='rgb(153, 255, 133)'
          initialColor='#142C14'
          finalColor='#8DA750'
        />
        <Typography variant='body1'>
          Posición {positionCode} finalizada correctamente
        </Typography>
      </Box>
    </Box>
  )
}
